<atn-ds-page [scrollable]="true">
  <atn-ds-page-header
    pageHeader
    [name]="dimensionNameSg()"
    [breadcrumbs]="breadcrumbsSg()"
  />

  <div class="atn-dimension">
    <div class="atn-dimension__main">
      <atn-ds-widget title="Dimension Summary">
        <div class="atn-dimension__widget-content atn-dimension__summary">
          <div>
            {{ dimensionDescriptionSg() }}
          </div>
          <div class="atn-dimension__attributes">
            <div class="atn-dimension__attribute">
              <div class="atn-dimension__attribute-name">Name</div>
              <div class="atn-dimension_attribute-value">
                {{ dimensionNameSg() }}
              </div>
            </div>
            <div class="atn-dimension__attribute">
              <div class="atn-dimension__attribute-name">ID</div>
              <div class="atn-dimension__attribute-value">
                {{ dimensionIdSg() }}
              </div>
            </div>
            <div class="atn-dimension__attribute">
              <div class="atn-dimension__attribute-name">Partial ID</div>
              <div class="atn-dimension__attribute-value">
                {{ partialIdSg() }}
              </div>
            </div>
            <div class="atn-dimension__attribute">
              <div class="atn-dimension__attribute-name">
                Standard Dimension
              </div>
              <div class="atn-dimension__attribute-value">
                {{ isStandardDimensionSg() }}
              </div>
            </div>
          </div>
        </div>
      </atn-ds-widget>
      <atn-ds-widget title="Entities">
        <div class="atn-dimension__widget-content atn-dimension__models">
          @for (entity of dimensionEntitiesSg(); track $index) {
            <atn-model-card
              class="atn-dimension__model"
              [model]="entity"
              (click)="entityClickedHandler(entity.id)"
            />
          }
        </div>
      </atn-ds-widget>

      @let dimensionSnapshots = dimensionSnapshotsSg();
      @if (dimensionSnapshots.length > 0) {
        <atn-ds-widget title="Snapshots">
          <div class="atn-dimension__widget-content atn-dimension__models">
            @for (snapshot of dimensionSnapshots; track $index) {
              <atn-model-card
                class="atn-dimension__model"
                [model]="snapshot"
                (click)="snapshotClickedHandler(snapshot.id)"
              />
            }
          </div>
        </atn-ds-widget>
      }
    </div>
    @if (dimensionSg()) {
      <div class="atn-dimension__side">
        <atn-ds-widget title="Notes">
          <div class="atn-dimension__widget-content">
            <!-- TODO: finish implementing terms -->
            Coming soon!
          </div>
        </atn-ds-widget>
      </div>
    }
  </div>
</atn-ds-page>
